import {useDispatch, useSelector, useStore} from "react-redux";

import type {RevaDispatch, RevaExtraArgs, RevaRootState, RevaStore} from "./store";

/** Typed hook to use instead of `useDispatch()` */
export const useRevaDispatch = useDispatch.withTypes<RevaDispatch>();

/** Typed hook to use instead of `useSelector()` */
export const useRevaSelector = useSelector.withTypes<RevaRootState>();

/** Typed hook to use instead of `useStore()` */
export const useRevaStore = useStore.withTypes<RevaStore>();

/** ThunkAction to use for alle Thunks against the Reva Redux Store. */
export type RevaThunkAction<R> = (
    dispatch: RevaDispatch,
    getState: () => RevaRootState,
    extraArgument: RevaExtraArgs,
) => R;
